import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : null;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!API) return "Signup is not available right now. Please try again later.";
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msg = detail.map((e) => (typeof e?.msg === "string" ? e.msg : "")).join(" ");
    return /email/i.test(msg) ? "Please enter a valid email address." : msg || "Please check your details.";
  }
  return String(detail?.msg ?? detail);
}

export async function joinWaitlist(email) {
  if (!API) throw new Error("No backend");
  const { data } = await axios.post(`${API}/waitlist`, { email });
  return data;
}
